import { useState, type FormEvent } from 'react';
import { useNavigate } from 'react-router';
import { post } from '../lib/api';
import { useStore, type User } from '../store';

export function Reset() {
  const { setUser } = useStore();
  const nav = useNavigate();
  const [err, setErr] = useState('');
  const token = new URLSearchParams(location.search).get('token') ?? '';
  const submit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault(); const o = Object.fromEntries(new FormData(e.currentTarget).entries()) as Record<string, string>;
    try { const r = await post<{ user: User }>('/api/auth/reset', { token, password: o.password }); setUser(r.user); nav('/'); } catch (ex) { setErr((ex as Error).message); }
  };
  return <div className="landing"><form className="panel" style={{ maxWidth: 420, width: '100%' }} onSubmit={submit}><h2>Choose a new password</h2>
    <div className="field"><label htmlFor="pw">New password</label><input id="pw" name="password" type="password" required minLength={8} autoComplete="new-password" /></div>
    <div className="err">{err}</div><button className="btn primary block">Save and sign in</button></form></div>;
}
